import { TPatientMedEvent } from 'src/types/med-event'
import { useTranslation } from 'react-i18next'
import Card from 'src/components/card/card.component'
import { TPatientMedAlert } from 'src/types/med-alert'
import MedicalAlertList from 'src/components/medical-alert-list/medical-alert-list.component'
import AppointmentInfo from './appointment-info.component'
import { TFollowup } from 'src/types/followup'

interface AllAppointmentsProps {
  patientMedEvents: TPatientMedEvent[]
  patientMedAlerts: TPatientMedAlert[]
  currentFollowup: TFollowup
  currentPatientFollowupId: number
  title?: string
}

const AllAppointments = ({
  patientMedEvents,
  patientMedAlerts,
  currentFollowup,
  currentPatientFollowupId,
  title,
}: AllAppointmentsProps) => {
  const { t } = useTranslation()
  const sortedPatientMedEvents: TPatientMedEvent[] =
    patientMedEvents?.slice().sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()) || []

  const otherPatientMedAlertForThisFollowup =
    patientMedAlerts?.filter(
      (medAlert) => !medAlert.PatientMedEventId && medAlert.PatientFollowupId === currentPatientFollowupId,
    ) || []

  if (sortedPatientMedEvents.length === 0) {
    return null
  }

  return (
    <Card title={title || t('components.patient.patient-file.body.followup-details.appointments')}>
      {sortedPatientMedEvents.map((pme) => {
        const patientMedAlertForThisMedEvent =
          patientMedAlerts?.filter((medalert) => medalert.PatientMedEventId === pme.id) || []
        const patientMedAlertComponent =
          patientMedAlertForThisMedEvent.length > 0 ? (
            <div className="c-flex-1">
              <h6 className="c-font-semibold c-mb-2 c-text-sm">
                {t('components.patient.patient-file.body.followup-details.patient-reviews')}
              </h6>
              <MedicalAlertList
                medicalAlertList={patientMedAlertForThisMedEvent}
                medAlertSize="SMALL"
                isWorkflow
              />
            </div>
          ) : null
        return (
          <AppointmentInfo patientMedEvent={pme} currentFollowup={currentFollowup} key={pme.id}>
            {patientMedAlertComponent}
          </AppointmentInfo>
        )
      })}
      {otherPatientMedAlertForThisFollowup.length > 0 && (
        <div className="c-my-4">
          <h6 className="c-font-semibold c-mb-2">
            {t('components.patient.patient-file.body.followup-details.patient-reviews-for-this-followup')}
          </h6>
          <MedicalAlertList
            medicalAlertList={otherPatientMedAlertForThisFollowup}
            medAlertSize="SMALL"
            isWorkflow
          />
        </div>
      )}
    </Card>
  )
}

export default AllAppointments
